//Bilder
import schiebetor_1 from './schiebetor_1.jpg';
import schiebetor_2 from './schiebetor_2.jpg';

//Videos
const video_1 = "https://www.youtube.com/embed/wVGxQKuVrbQ";

export const portfolio_schiebetor = [
    {product_img: schiebetor_1},
    {product_img: schiebetor_2}
]

export const portfolio_schiebetor_videos = [
    {product_video: video_1, titel: 'Schiebetor'}
]